import React from "react";
import { Link } from "react-router-dom";

// Üyelik yenileme rehberi: e-posta ve SMS'teki "nasıl yapılır" bağlantısının açtığı sayfa.
// Giriş gerektirmez, telefonda okunacak şekilde tek sütun.
// Ekran görüntüleri public/Assets/rehber altında; ücret rakamı bilerek yok (panelden değişebiliyor).
// Görseller uygulama sürümü 1.9.0'dan alındı; ekranlar değişirse hem görseller hem SURUM güncellenmeli.

const SURUM = "Eylül 2026 · uygulama sürümü 1.9.0";
const GORSEL = "/Assets/rehber";

const renk = {
  mor: "#667eea",
  metin: "#1e293b",
  soluk: "#64748b",
  cizgi: "#e2e8f0",
  zemin: "#f8fafc",
  uyariZemin: "#fef3c7",
  uyariCizgi: "#f59e0b",
};

const stil = {
  sayfa: {
    minHeight: "100vh",
    background: renk.zemin,
    color: renk.metin,
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  },
  baslikAlani: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "#fff",
    padding: "28px 20px 32px",
    textAlign: "center",
  },
  govde: { maxWidth: "640px", margin: "0 auto", padding: "0 16px 48px" },
  bolum: {
    background: "#fff",
    border: `1px solid ${renk.cizgi}`,
    borderRadius: "16px",
    padding: "18px 16px",
    margin: "16px 0",
  },
  bolumBaslik: { fontSize: "18px", fontWeight: 700, margin: "0 0 6px" },
  metin: { fontSize: "15px", lineHeight: 1.6, color: renk.metin, margin: "0 0 12px" },
  soluk: { fontSize: "14px", lineHeight: 1.6, color: renk.soluk },
  gorsel: {
    width: "100%",
    maxWidth: "320px",
    display: "block",
    margin: "12px auto 0",
    borderRadius: "12px",
    border: `1px solid ${renk.cizgi}`,
  },
  rozet: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "26px",
    height: "26px",
    borderRadius: "50%",
    background: renk.mor,
    color: "#fff",
    fontSize: "14px",
    fontWeight: 700,
    marginRight: "8px",
    flexShrink: 0,
  },
  adimBaslik: { display: "flex", alignItems: "center", fontSize: "17px", fontWeight: 700, margin: "0 0 8px" },
  uyari: {
    background: renk.uyariZemin,
    border: `1px solid ${renk.uyariCizgi}`,
    borderRadius: "14px",
    padding: "14px 16px",
    margin: "16px 0",
    fontSize: "15px",
    lineHeight: 1.6,
  },
  buton: {
    display: "block",
    width: "100%",
    textAlign: "center",
    background: renk.mor,
    color: "#fff",
    textDecoration: "none",
    padding: "16px",
    borderRadius: "14px",
    fontSize: "17px",
    fontWeight: 700,
    margin: "24px 0 8px",
  },
  sss: { borderTop: `1px solid ${renk.cizgi}`, paddingTop: "14px", marginTop: "14px" },
  sssSoru: { fontSize: "15px", fontWeight: 700, margin: "0 0 4px" },
};

const Gorsel = ({ ad, alt }) => (
  <img src={`${GORSEL}/${ad}`} alt={alt} loading="lazy" style={stil.gorsel} />
);

const Adim = ({ no, baslik, children }) => (
  <div style={stil.bolum}>
    <h3 style={stil.adimBaslik}>
      <span style={stil.rozet}>{no}</span>
      {baslik}
    </h3>
    {children}
  </div>
);

const Soru = ({ soru, children }) => (
  <div style={stil.sss}>
    <p style={stil.sssSoru}>{soru}</p>
    <p style={{ ...stil.soluk, margin: 0 }}>{children}</p>
  </div>
);

export default function YenilemeRehberi() {
  return (
    <div style={stil.sayfa}>
      <div style={stil.baslikAlani}>
        <h1 style={{ fontSize: "24px", fontWeight: 800, margin: "0 0 8px" }}>
          Üyeliğimi nasıl yenilerim?
        </h1>
        <p style={{ fontSize: "15px", opacity: 0.9, margin: 0 }}>
          Yenileme işlemini kendi telefonunuzdan, birkaç dakikada yapabilirsiniz.
        </p>
      </div>

      <div style={stil.govde}>
        <div style={stil.bolum}>
          <h2 style={stil.bolumBaslik}>Kısaca</h2>
          <p style={stil.metin}>
            Uygulamadan <strong>Üyeliğimi Yenile</strong>'ye dokunuyorsunuz, açılan sayfada telefon
            numaranızla giriş yapıyorsunuz ve kartınızla ödüyorsunuz. Hediye kodunuz varsa aynı
            sayfada kullanabilirsiniz.
          </p>
          <p style={{ ...stil.soluk, margin: 0 }}>
            Yenileme, üyeliğinizin bitmesine <strong>30 gün kala</strong> açılır. Daha erken
            girerseniz ödeme bölümü görünmez; zamanı gelince size hatırlatma göndeririz.
          </p>
        </div>

        <h2 style={{ ...stil.bolumBaslik, marginTop: "28px" }}>
          Uygulamada yenileme üç yerden başlar
        </h2>
        <p style={stil.soluk}>Hangisi size kolay geliyorsa onu kullanın, üçü de aynı sayfayı açar.</p>

        <Adim no="1" baslik="Ayarlar">
          <p style={stil.metin}>
            Sağ üstteki menüden <strong>Ayarlar</strong>'a girin, aşağı inin ve{" "}
            <strong>Üyeliğimi Yenile</strong>'ye dokunun. Üyeliğinizin bitiş tarihi de burada yazar.
          </p>
          <Gorsel ad="02-ayarlar-uyeligimi-yenile.png" alt="Ayarlar ekranında Üyeliğimi Yenile satırı" />
        </Adim>

        <Adim no="2" baslik="Profil Düzenle">
          <p style={stil.metin}>
            Profil sayfanızdaki kalem simgesine dokunun, en alttaki <strong>Üyeliğiniz</strong>{" "}
            kartında <strong>Yenile</strong> yazar.
          </p>
          <Gorsel
            ad="01-profili-duzenle-uyelik-karti.png"
            alt="Profil Düzenle ekranındaki üyelik kartı"
          />
        </Adim>

        <Adim no="3" baslik="Süreniz dolduysa açılışta">
          <p style={stil.metin}>
            Üyeliğiniz bittiyse ve 7 günlük ek süre de geçtiyse uygulama bu ekranla açılır.{" "}
            <strong>Üyeliğimi Yenile</strong>'ye dokunmanız yeterli. Ödemeden sonra{" "}
            <strong>Yeniledim, kontrol et</strong> ile uygulamaya dönersiniz.
          </p>
          <Gorsel ad="03-kilit-ekrani.png" alt="Üyelik süresi dolduğunda görünen kilit ekranı" />
        </Adim>

        <h2 style={{ ...stil.bolumBaslik, marginTop: "28px" }}>Açılan sayfada ne yapacaksınız</h2>

        <Adim no="4" baslik="Telefon numaranızı girin">
          <p style={stil.metin}>
            Üyeliğinizde kayıtlı cep telefonu numaranızı yazın ve <strong>Kod Gönder</strong>'e
            dokunun.
          </p>
          <Gorsel ad="04-telefon-girisi.png" alt="Yenileme sayfasında telefon numarası girişi" />
        </Adim>

        <Adim no="5" baslik="Gelen kodu yazın">
          <p style={stil.metin}>
            Numaranıza 4 haneli bir kod gelir, 3 dakika geçerlidir. Kod gelmezse{" "}
            <strong>Numarayı değiştir</strong> ile numaranızı kontrol edebilir ya da yeni kod
            isteyebilirsiniz.
          </p>
          <Gorsel ad="05-sms-kodu.png" alt="SMS ile gelen dört haneli kodun girildiği ekran" />
        </Adim>

        <Adim no="6" baslik="Onaylayın ve ödeyin">
          <p style={stil.metin}>
            Üyeliğinizin yeni bitiş tarihi ekranda yazar. Üyelik sözleşmesi ile KVKK & Gizlilik
            Politikası kutularını işaretleyip <strong>Kartla Öde</strong>'ye dokunun. Güncel ücret
            ekranınızda görünür.
          </p>
          <Gorsel ad="06-odeme-ekrani.png" alt="Onay kutuları ve kartla ödeme butonu" />
        </Adim>

        <Adim no="7" baslik="Hediye kodunuz varsa">
          <p style={stil.metin}>
            Ödeme butonunun altındaki <strong>Hediye kodum var</strong> bağlantısına dokunun, kodu
            yazın ve kullanın. Kart bilgisi istenmez.
          </p>
          <Gorsel ad="07-hediye-kodu.png" alt="Hediye kodu giriş alanı" />
        </Adim>

        <div style={stil.uyari}>
          <strong>Güvenliğiniz için:</strong> SMS ile gelen kodu ve kart bilgilerinizi hiç kimseyle
          paylaşmayın. Ekibinizden biri ya da bizim adımıza arayan biri bu bilgileri isterse
          vermeyin. Yenilemeyi kendi telefonunuzdan kendiniz yapabilirsiniz.
        </div>

        <div style={stil.bolum}>
          <h2 style={stil.bolumBaslik}>Sık sorulanlar</h2>

          <Soru soru="Uygulamaya giremiyorum, ne yapacağım?">
            Giriş ekranının altındaki "Üyeliğinizin süresi mi doldu? Yenileyin" bağlantısı da aynı
            yenileme sayfasını açar. Giriş yapmanız gerekmez.
          </Soru>

          <Soru soru="Yurt dışı numaram var, SMS gelmiyor">
            Yenileme sayfasındaki E-posta sekmesinden, e-posta adresiniz ve uygulama şifrenizle giriş
            yapabilirsiniz.
          </Soru>

          <Soru soru="Numaram değişti">
            Kayıtlı numaranıza kod gidemeyeceği için E-posta sekmesinden giriş yapın, ardından
            destek ekibimizle iletişime geçin.
          </Soru>

          <Soru soru="Şimdiden yenileyebilir miyim?">
            Yenileme bitişe 30 gün kala açılır. Daha önce girdiğinizde sayfa üyeliğinizin ne zaman
            biteceğini gösterir, ödeme bölümü görünmez.
          </Soru>

          <Soru soru="Süresi dolduktan sonra ne kadar vaktim var?">
            Bitiş tarihinden sonra 7 gün ek süreniz olur; bu sürede uygulamayı kullanmaya devam
            edersiniz. Ek sürede kullandığınız günler hediyemizdir: süresi dolduktan sonra yenilerseniz
            yeni yılınız ödeme gününüzden başlar. Bitişten önce yenilerseniz yeni yılınız eski bitiş
            tarihinizin üzerine eklenir, gün kaybetmezsiniz.
          </Soru>

          <Soru soru="Ödedim ama uygulama hâlâ kilitli">
            Kilit ekranındaki "Yeniledim, kontrol et" düğmesine dokunun. Birkaç saniye içinde
            açılmazsa uygulamayı kapatıp yeniden açın.
          </Soru>
        </div>

        <Link to="/yenile" style={stil.buton}>
          Yenileme sayfasına git
        </Link>

        <p style={{ ...stil.soluk, textAlign: "center", marginTop: "8px" }}>
          Takıldığınız yerde <Link to="/iletisim">destek ekibimize yazabilirsiniz</Link>.
        </p>
        <p style={{ ...stil.soluk, textAlign: "center", fontSize: "13px", marginTop: "18px" }}>
          {SURUM}
        </p>
      </div>
    </div>
  );
}
